import React from 'react'
import { styles } from '../../styles'
import { ComputersCanvas, EarthCanvas } from './canvas'
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section className={`relative  w-full h-screen mx-auto`}>
      <div
        className={`absolute inset-0 top-[120px]  max-w-7xl mx-auto ${styles.paddingX} md:flex justify-between items-start `}
      ><div className='flex pt-[100px]'>    
        <div className='flex flex-col justify-center items-center mt-5'>
          <div className='w-5 h-5 rounded-full bg-primary' />
          <div className='w-1 sm:h-80 h-40 violet-gradient' />
        </div>

        <div>
          <h1 className={`${styles.heroHeadText} text-white`}>
            <span className='text-primary'>Hello World</span>
          </h1>
          <h1 className={`${styles.heroSubText} text-white`}>
            Hi, I'm <span className='text-primary'>Sourabh</span>
          </h1>
          <p className={`${styles.heroSubText} mt-2 text-white-100`}>
            I develop App and user <br className='sm:block hidden' />
            interfaces  web applications
          </p>
        </div>
      </div>
      <div
      className=' relative md:h-[850px] h-[500px]  md:w-[750px] md:mt-[-100px] mt-[-100px] md:mr-[-190px]  '
      >
        <EarthCanvas/>
      </div>
      </div>
    </section>
  )
}

export default Hero